import { values } from "./object.utils";

export const isEnum = <T extends Record<string, string | number>>(
    enumObject: T,
    value: unknown
): value is T[keyof T] => {
    return values(enumObject).includes(value as T[keyof T]);
};
